// useIdleDrift — Phase 2.5c.
//
// When the orb isn't speaking and isn't anchored to a scene element, give
// it a slow ambient drift so it feels alive rather than frozen. The drift
// is small (±18px) and slow (12s cycle) — peripheral, not attention-grabbing.
//
// Implementation: lerp through a few sampled offset points using a setTimeout
// loop. setInterval fires reliably even in unfocused tabs (unlike rAF which
// throttles to 0Hz). The Orb consumes (x, y) and merges them into its
// `animate` prop alongside scale and filter.

import { useEffect, useState } from 'react';

const POINTS: Array<[number, number]> = [
  [ 0,    0  ],
  [ 14,  -10 ],
  [ -8,  -16 ],
  [ -16,  6  ],
  [ 4,    14 ],
];
const SEGMENT_MS = 2400;

export function useIdleDrift(active: boolean): { x: number; y: number } {
  const [pt, setPt] = useState<{ x: number; y: number }>({ x: 0, y: 0 });
  useEffect(() => {
    if (!active) {
      setPt({ x: 0, y: 0 });
      return;
    }
    let i = 0;
    const tick = () => {
      i = (i + 1) % POINTS.length;
      const [x, y] = POINTS[i];
      setPt({ x, y });
    };
    const id = setInterval(tick, SEGMENT_MS);
    return () => clearInterval(id);
  }, [active]);
  return pt;
}
